import { Button, styled, Typography } from "@mui/material";
import React from "react";

const GrowComponent = () => {
  return (
    <Wrapper>
      <div className="container">
        <div>
          <Typography className="small_text">Ready to Grow Your</Typography>
          <Typography className="big_text">School Digitally?</Typography>
        </div>
        <Button
          className="button"
          variant="contained"
          size="large"
          href="https://calendly.com/ekalsutra"
          target="_blank"
        >
          Let's start the Demo
        </Button>
      </div>
    </Wrapper>
  );
};

export default GrowComponent;
const Wrapper = styled("div")`
  margin: 30px auto;

  .container {
    padding: 0 20px;
    background-repeat: no-repeat;
    background-image: url("/landingPage/grow-image.png");
    background-position: center;
    background-size: contain;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    .big_text {
      color: #fff;
      font-weight: 600;
    }
    .small_text {
      color: #fff;
    }
    .button {
      background-color: #fff;
      border-radius: 10px;
      color: #2789fd;
      font-weight: 600;

      box-shadow: none;
    }
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    .container {
      height: 120px;
      width: 350px;
      .big_text {
        font-size: 16px;
      }
      .small_text {
        font-size: 11px;
      }
      .button {
        width: 130px;
        font-size: 10px;
        margin-right: 30px;
      }
    }
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    .container {
      height: 200px;
      width: 700px;
      .big_text {
        font-size: 30px;
        color: #fff;
        font-weight: 600;
      }
      .small_text {
        font-size: 20px;
        color: #fff;
      }
      .button {
        width: 220px;
        font-size: 14px;
        margin-right: 80px;
      }
    }
  }
`;
